import { lazy } from 'react';
const PayrollAdditions = lazy(() => import('./payrollAdditions'));

const PayrollAdditionsRoutes = [
  {
    path: '/payroll-additions',
    component: PayrollAdditions
  }
];

export default PayrollAdditionsRoutes;
